export default __webpack_public_path__ + "static/media/018-desert.49854639.svg";